export default __webpack_public_path__ + "static/media/user.5fa55283.jpg";